




import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as api from '@/api';
import histogram from '@/components/Charts/histogram.vue';
import moment from 'moment';

@Component({ components: { histogram } })
export default class BarChart extends Vue {
  chartOptions = {};
  listData: any = [];
  listQuery: any = {
    currentStartDate: '',
    startDate: null,
    endDate: null,
    type: '',
  };

  async fetchData() {
    const data: any = await api.Yq.getEventStatistics_GET({
      st: this.listQuery.st ? new Date(new Date(new Date(this.listQuery.st).toLocaleDateString()).getTime()) : null,
      et: this.listQuery.et
        ? new Date(new Date(new Date(this.listQuery.et).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
        : null,
      startDate: this.listQuery.type ? this.listQuery.currentStartDate : null,
      endDate: this.listQuery.endDate,
      type: this.listQuery.type,
      city: '',
      county: '',
    });
    let dataArr = data.data.result;
    //先清空，避免查询影响
    this.listQuery.currentStartDate = '';
    this.listQuery.currentStartDate = data.data.currentStartDate;
    //先清空，避免查询影响
    this.listData = [];
    //组装数据
    for (let i = 1; i < dataArr.length - 1; i++) {
      let item: any = {};
      item.id = dataArr[i][0];
      item.event = dataArr[i][1];
      item.totalNumber = dataArr[i][2];
      let dateArr: any = [];
      for (let j = 0; j < dataArr[0].length - 3; j++) {
        let dateItem: any = {};
        dateItem.date = dataArr[0][j + 3];
        dateItem.number = dataArr[i][j + 3];
        dateArr.push(dateItem);
      }

      item.dateArr = dateArr;
      this.listData.push(item);
    }

    if (this.listData && this.listData.length > 0) {
      this.getChart();
    }
  }

  getWeekDay(date: Date) {
    let week;
    let dateFormat = new Date(moment(date).format('YYYY-MM-DD'));
    if (dateFormat.getDay() == 0) week = '星期日';
    if (dateFormat.getDay() == 1) week = '星期一';
    if (dateFormat.getDay() == 2) week = '星期二';
    if (dateFormat.getDay() == 3) week = '星期三';
    if (dateFormat.getDay() == 4) week = '星期四';
    if (dateFormat.getDay() == 5) week = '星期五';
    if (dateFormat.getDay() == 6) week = '星期六';
    return week;
  }

  getChart() {
    let titleName =
      '<span style="font-size:13px;">' +
      moment(new Date(this.listData[0].dateArr[0].date)).format('YYYY-MM-DD') +
      '~' +
      moment(new Date(this.listData[0].dateArr[this.listData[0].dateArr.length - 1].date)).format('YYYY-MM-DD') +
      '</span>';
    let values: any = [];

    let types: any = [];
    if (this.listData) {
      this.listData.forEach((item: any) => {
        values.push(Number(item.totalNumber));
        types.push(item.event);
      });
    }

    let template = {
      chart: {
        type: 'column',
        backgroundColor: 'transparent', // 整体背景透
      },
      title: {
        text: titleName,
        style: { color: '#fff' },
      },
      xAxis: {
        categories: types,
        crosshair: true,
        accessibility: {
          description: 'Countries',
        },
        labels: {
          style: {
            color: '#ccc', // 这里设置字体颜色
          },
        },
      },
      yAxis: {
        title: { text: '数量(条)' },
        allowDecimals: false,
      },
      credits: {
        //去掉水印
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        valueSuffix: ' (1000 MT)',
      },
      plotOptions: {
        column: {
          // borderRadius: 6,
          pointPadding: 0.2,
          borderWidth: 0,
        },
      },
      series: [
        {
          name: '事件类别',
          data: values,
          // color: '#2d8cf0',
          color: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, '#2d8cf0'], // 顶部亮色
              [1, '#0044ff'], // 底部深色
            ],
          },
          shadow: true, // 柱子阴影
        },
      ],
    };
    this.chartOptions = template;
  }

  setTypeAndFetch(type: string) {
    console.log('[ 99 ] >', 99);
    this.listQuery.type = type;
    this.fetchData();
  }

  mounted() {
    this.fetchData();
  }
}
